/**
 * Board persistence helpers (Feature #3).
 * A board is stored as its serialized scene JSON (the main tree is NOT E2E in
 * v1 — CLAUDE.md §8), keyed by a file in the RYFE backend.
 */

import { serializeAsJSON } from "@excalidraw/excalidraw/data/json";

import type { ExcalidrawElement } from "@excalidraw/element/types";
import type {
  AppState,
  BinaryFiles,
  ExcalidrawInitialDataState,
} from "@excalidraw/excalidraw/types";

/** Serialize a scene to the string stored as the file blob. */
export function serializeScene(
  elements: readonly ExcalidrawElement[],
  appState: Partial<AppState>,
  files: BinaryFiles,
): string {
  return serializeAsJSON(elements, appState, files, "local");
}

/** Parse a stored board blob into Excalidraw initial data (tolerant of empty). */
export function parseScene(text: string): ExcalidrawInitialDataState {
  if (!text || !text.trim()) {
    return { elements: [], appState: {}, files: {} };
  }
  try {
    const data = JSON.parse(text);
    return {
      elements: data.elements ?? [],
      appState: data.appState ?? {},
      files: data.files ?? {},
    };
  } catch {
    return { elements: [], appState: {}, files: {} };
  }
}
